import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/index/periods/1.jpg")